export default __webpack_public_path__ + "static/media/bg_ballons1.0cfdf293.png";